export default __webpack_public_path__ + "static/media/Audrey.2b634f6c.png";